import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import { Grid, makeStyles } from '@material-ui/core';
import { Assignment, Person, Room, Group } from '@material-ui/icons';
import { getAppointmentColor } from '../../theme/colors';
import { roundNumber } from '../../utils/helper_functions';
import { useFormContext } from 'react-hook-form';
import CheckBoxInput from '../ui_components/checkbox_input';
import { set } from 'date-fns';
import { patchAppointment } from '../../store/actions/appointments/appointments_action';
import { useSnackbar } from 'notistack';
import { Typography, IconButton} from '@material-ui/core';
import { Description } from '@material-ui/icons';
import DigitalRecord from "./digital_record";
import TemporaryDrawer from '../ui_components/temporary_drawer';
import { RecentActors } from '@material-ui/icons';
import DigitalRecordModal from '../customer/digital_record_modal';

const useStyles = makeStyles(({ palette }) => ({
    root: {
        '& svg': {
            color: (props) => getAppointmentColor(props)
        }
    },
	icon: {
		color: palette.action.active
	},
	textCenter: {
		textAlign: 'center'
	},
    checkBoxPadding: {
        paddingLeft: 22
    },
    iconButtonLabel: {
        display: 'flex',
        flexDirection: 'column'
    }
}));

const Content = (props) => {
    const { defaultProps, isDoctor } = props;
    const { appointmentData } = defaultProps;
    const { root, icon, textCenter, checkBoxPadding, iconButtonLabel } = useStyles(appointmentData);
    const { article, price, customer, worker, place, isPayed: payed } = appointmentData;
    const { enqueueSnackbar } = useSnackbar();
    const { control } = useFormContext();
    const dispatch = useDispatch();
    const [isPayed, setIsPayed] = useState(Boolean(payed));

    const [recordFormShow, setRecordFormShow] = useState(false);
    const [digitalRecordOpen, setDigitalRecordOpen] = useState(false);

    const handleClick = () => {
        setRecordFormShow(true);
    }

    const handleClickDigitalRecord = () => {
        setDigitalRecordOpen(true);
    }

    const handleCheckIsPayed = async (e) => {
        const payingDate = set(new Date(), { hours: 0, minutes: 0, seconds: 0 }).toLocaleString();
        const response = await dispatch(patchAppointment({ id: appointmentData.id, isPayed: e.target.checked, payingDate }))
        const { isPayed } = response;
        setIsPayed(isPayed);
        enqueueSnackbar('Uspešno izmenjen termin', { variant: 'success' });
    }

    return (
        <AppointmentTooltip.Content
            {...defaultProps}
            appointmentData={appointmentData}
            className={root}
        >
            <Grid container alignItems="center">
                
                <Grid item xs={2} className={textCenter}>
                    <Assignment className={icon} />
                </Grid>
                {article &&
                    <Grid item xs={10}>
                        {article?.name || ''} - {roundNumber(price) || ''}
                    </Grid>
                }
                {place &&
                    <>
                        <Grid item xs={2} className={textCenter}>
                            <Room className={icon} />
                        </Grid>
                        <Grid item xs={10}>
                            {place.name}
                        </Grid>
                    </>
                }
                {customer &&
                    <>
                        <Grid item xs={2} className={textCenter}>
                            <Person className={icon} />
                        </Grid>
                        <Grid item xs={10}>
                            {customer?.firstName} {customer?.lastName} {customer?.phone && `(${customer?.phone})`}
                        </Grid>
                    </>
                }
                {worker &&
                    <>
                        <Grid item xs={2} className={textCenter}>
                            <Group className={icon} />
                        </Grid>
                        <Grid item xs={10}>
                            {worker?.firstName} {worker?.lastName} {worker?.phone && `(${worker?.phone})`}
                        </Grid>
                    </>
                }
                {isDoctor === false &&
                    <>
                        <Grid item xs={2} className={checkBoxPadding}>
                            <CheckBoxInput
                                name="isPayed"
                                control={control}
                                value={isPayed}
                                onChange={handleCheckIsPayed}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            Plaćeno?
                        </Grid>
                    </>
                }
                <Grid container justify="center">
                    <IconButton classes={{ label: iconButtonLabel }} onClick={handleClick}>
                        <Description fontSize="default" />
                        <Typography variant="caption" gutterBottom>
                            Izveštaj
                        </Typography>
                    </IconButton>
                        <TemporaryDrawer
                            fullScreen
                            open={recordFormShow}
                            setOpen={setRecordFormShow}
                            component={
                                <DigitalRecord
                                    setOpen={setRecordFormShow}
                                    appointmentData={appointmentData}
                                    onHide={defaultProps.onHide}
                                />
                            }
                        />
                    {appointmentData.customer &&
                        <IconButton classes={{ label: iconButtonLabel }} onClick={() => handleClickDigitalRecord()}>
                            <RecentActors fontSize="default" />
                            <Typography variant="caption" gutterBottom>
                                Digitalni karton
                            </Typography>
                        </IconButton>
                    }
                </Grid>
            </Grid>
            <DigitalRecordModal
                customerUuid={appointmentData.customer && appointmentData.customer.uuid }
                customerName={appointmentData.customer && `${appointmentData.customer.firstName} ${appointmentData.customer.lastName}`}
                customerBirthYear={appointmentData.customer && appointmentData.customer.customerBirthYear}
                open={digitalRecordOpen}
                setOpen={setDigitalRecordOpen}
            />
        </AppointmentTooltip.Content>
    )
}

Content.propTypes = {
    defaultProps: PropTypes.object,
    isDoctor: PropTypes.bool
}

export default Content;
